<template>
  <div id="intro-3" class="intro-box">
    <div class="intro-box__wrapper">
      <div class="intro-box__header">
        <h3>Deductions</h3>
      </div>

      <div class="intro-box__content">
        <p>Let's configure any deductions when calculating the commission. Deductions will be
          removed before applying the percentage if using percentage calculations.</p>

        <div class="intro-box__actions">
          <div class="form-field">
            <div class="grid-x grid-padding-x align-middle">
              <div class="cell shrink">
                <label style="width: 100px;">Discounts</label>
              </div>

              <div class="cell auto">
                <label :class="[discount === 'vendor' ? 'active' : '', 'radio-choice']"
                       for="discount-vendor" @click="changeDiscount('vendor')">Vendor
                  <input id="discount-vendor" class="hidden" type="radio"
                         name="discount" value="vendor"
                         :checked="discount === 'vendor' ? checked : ''">
                </label>

                <label :class="[discount === 'store' ? 'active' : '', 'radio-choice']"
                       for="discount-store" @click="changeDiscount('store')">Store
                  <input id="discount-store" class="hidden" type="radio"
                         name="discount-store" value="dark"
                         :checked="discount === 'store' ? checked : ''">
                </label>

                <label :class="[discount === 'equal' ? 'active' : '', 'radio-choice']"
                       for="discount-equal" @click="changeDiscount('equal')">Equal
                  <input id="discount-equal" class="hidden" type="radio"
                         name="discount-equal" value="equal"
                         :checked="discount === 'equal' ? 'checked' : ''">
                </label>
              </div>
            </div>
          </div>

          <!--
          <div class="form-field">
            <div class="grid-x grid-padding-x align-middle">
              <div class="cell shrink">
                <label style="width: 100px;">Taxes</label>
              </div>

              <div class="cell auto">
                <label class="radio-choice" for="theme-light"
                       style="background: #fff; color: #333;" @click="theme('light')">Yes
                  <input id="theme-light" class="hidden" type="radio" name="theme"
                         value="light">
                </label>

                <label class="radio-choice active" for="theme-dark"
                       style="background: #333; color: #fff;" @click="theme('dark')">No
                  <input id="theme-dark" class="hidden" type="radio" name="theme"
                         value="dark" checked="checked">
                </label>
              </div>
            </div>
          </div>
          -->

<!--          <div class="form-field">-->
<!--            <div class="grid-x grid-padding-x align-middle">-->
<!--              <div class="cell shrink">-->
<!--                <label style="width: 100px;">Cost Per Item</label>-->
<!--              </div>-->

<!--              <div class="cell auto">-->
<!--                <label class="radio-choice" for="theme-light"-->
<!--                       style="background: #fff; color: #333;" @click="theme('light')">Yes-->
<!--                  <input id="theme-light" class="hidden" type="radio" name="theme"-->
<!--                         value="light">-->
<!--                </label>-->

<!--                <label class="radio-choice active" for="theme-dark"-->
<!--                       style="background: #333; color: #fff;" @click="theme('dark')">No-->
<!--                  <input id="theme-dark" class="hidden" type="radio" name="theme"-->
<!--                         value="dark" checked="checked">-->
<!--                </label>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
        </div>

        <div class="intro-box__action-helper" v-if="discount === 'vendor'">
          <p>Full discount on an order will be dedecuted from your vendor's
            commission. (Ex: Discount = $2.00; Commission = $5.00; Final
            Commission = $3.00)</p>
        </div>

        <div class="intro-box__action-helper" v-if="discount === 'store'">
          <p>The store will absorb all discount costs. Vendor comissions will
            have no deductions.</p>
        </div>

        <div class="intro-box__action-helper" v-if="discount === 'equal'">
          <p>Half of the discount on an order will be dedecuted from your
            vendor's commission. (Ex: Discount = $2.00; Commission = $5.00;
            Final Commission = $4.00)</p>
        </div>
      </div>
    </div>

    <div class="intro-box__footer">
      <div class="grid-x grid-padding-x">
        <div class="cell auto">
          <button class="button--wide button--alt" @click="changeStep(false)">Back</button>
        </div>

        <div class="cell auto">
          <button :class="['button--wide', discount === '' ? 'disabled': '']"
                  @click="changeStep">
            Next
          </button>

          <div style="padding: 10px 0;"><a href="https://calendly.com/support-visceral/onboarding" target="_blank">Need help with getting setup?</a></div>
        </div>
      </div>

<!--      <div class="intro-box__skip">configure later</div>-->
    </div>

    <div class="intro-box__pagination">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span class="active"></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>

<script>
import client from '@/mixins/client'

export default {
  mixins: [
    client
  ],
  data: function () {
    return {
      discount: ''
    }
  },
  methods: {
    changeDiscount (choice) {
      this.discount = choice
    },
    async saveDiscount () {
      await this.$store.dispatch(
        'updateAppSettings', {
          discount_share: this.discount
        }
      )
    },
    changeStep (next = true) {
      if (next) {
        this.saveDiscount()
        this.$emit('changeStep', next)
      } else if (!next) {
        this.$emit('changeStep', next)
      }
    }
  }
}
</script>

<style lang="scss">
  @import '../../../styles/mixins';
  @import '../../../styles/variables';
</style>



// WEBPACK FOOTER //
// src/apps/vendorconsignment/tutorials/step5.vue